module.exports = function() {
  return new Worker(__webpack_public_path__ + "aa3658f04f25852df6c3.worker.js");
};